// react
import React from "react";

type FormProgressProps = {
	height?: number;
	width?: number;
	pageCount: number;
	currentPage: number;
	onClick?: (page: number) => void;
};

type PageItem = {
	width: number;
	left: number;
	page: number;
	isActive: boolean;
};

const FormProgress = ({ pageCount, currentPage, width = 300, height = 30, onClick = () => {} }: FormProgressProps) => {
	/*
        Create a form progress bar.
    */

	// dot style
	const dotSize = 10;
	const pageWidth = width / pageCount;
	const dotPosition = {
		left: 0,
		top: (height - dotSize) * 0.5,
	};

	// backdot style
	const blipSize = height;

	const pages: PageItem[] = [];
	for (let i = 0; i < pageCount; i += 1) {
		pages.push({
			width: pageWidth,
			left: pageWidth * i,
			page: i,
			isActive: currentPage === i,
		});
	}

	return (
		<div className="cp-form-progress">
			<div className="progress-wrapper" style={{ width, height }}>
				<div className="timeline" style={{ top: (height - 2) * 0.5 }} />

				<div className="page-items">
					{pages.map((item) => (
						<div
							key={item.page}
							onClick={() => onClick(item.page)}
							style={{
								height,
							}}
							className="progress-item"
						>
							{item.isActive ? (
								<div
									className="blip"
									style={{
										width: blipSize,
										height: blipSize,
										left: -10,
										top: (height - blipSize) * 0.5,
									}}
								/>
							) : (
								""
							)}
							<div
								className="dot"
								style={{
									...dotPosition,
									width: dotSize - 4,
									height: dotSize - 4,
								}}
							/>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default FormProgress;
